import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "@/utils/exception";

async function getDynamicReport(functionName, params) {
  try {
    const _res = await DBOperationsComb.runDynamicReport(functionName, params);
    return _res;
  } catch (error) {
    Exception.catchException(error);
    throw error;
  }
}

export default {
  getDynamicReport
};
